 export const sections = [
    {
      title: 'Unlock the business potential of your organization with Tailored AI programmed for you.',
      description: 'Transform customer interactions, boost efficiency, and propel growth through the power of generative AI technology.'
    },
    {
      title: 'Deploy and Enjoy',
      description: 'Custom AI on any cloud or on-premises. Use our models to your data securely. '
    },
    {
      title: 'Custom AI trained support-bot for your team and customers',
      description: 'Create your own customized GPT and integrate it into your website to manage customer support, generate leads, interact with users, and much more. '
    },
    {
      title: 'Empower your marketing outreach !',
      description: 'Generate plagiarism free content for your blogs, email and social media post, ensuring originality and engagement with your audience.'
    },
    {
      title: 'Education',
      description: 'Prepare quizzes & questions based on any chapter or book you provide. Turn any PDF, Word, or Google Doc into a Test. '
    }, 
    {
      title: 'Legal, compliance, medical, or any other field',
      description: 'we\'re dedicated to empowering you with secure and private AI tailored specifically for your needs. Say goodbye to sifting through endless pages of information; our AI is here to swiftly provide you with the precise answers you seek.'
    },
    {
      title: 'Seeking answers beats skimming through pages',
      description: 'Chat with our PDF AI to swiftly summarize lengthy documents for you.'
    }
  ];
